import { createSelector } from '@ngrx/store';
import { selectShared } from './shared.selectors';

export const currentControllableObject = createSelector(
  selectShared,
  (state) => state.controllableObjects.currentControllableObject
);

export const controllableObjectList = createSelector(
  selectShared,
  (state) => state.controllableObjects.controllableObjectList
);
